import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import '../../../Airoom.css';
import { setContactsData } from "../../../Features/commonSlice";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import Pagination from "../../../core/common/pagination/Pagination";
import Ribbon, { ToggleButton } from "../../../core/common/ribbon/ribbon";
import TextField from "../../../core/common/textFields/TextField";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import { useGetAllContactsQuery } from "../../../services/EndPointsApis";
import '../../../style/css/index.css';
import { svgIcons } from "../../../style/fonts/SvgIcons";
import ActiveUserModal from "./ActiveUserModal";
import ContactsSidebar from "./ContactsSidebar";
import FilterModalContacts from "./FilterModalContacts";
import TableHeading from '../../../core/common/tableHeading/TableHeading';
import ManageColumnContacts from './ManageColumnContacts/ManageColumnContacts';
import { initialColumnContacts } from './ManageColumnContacts/InitialColumns';
import FilterComponent from '../../../core/common/FilterComponent';
import { CSVLink } from 'react-csv';
import dayjs from "dayjs";

const Contacts = () => {
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const [showfilterModal, setShowfilterModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState('');
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('');
  const [currentToggleState, setCurrentToggleState] = useState(false);

  const navigate = useNavigate()
  const dispatch = useDispatch();

  //All Contacts API
  const { data: allContacts, refetch: refetchContacts, isLoading,isFetching:isFetchingData } = useGetAllContactsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || ' ',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  const { data: allContactsCSV, isFetching } = useGetAllContactsQuery({
    pageNumber: pageNumber,
    pageSize: 1000,
    searchStr: searchStr || ' ',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  //Table CustomHook
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: contactData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick
  } = useTableSelection(allContacts?.result?.data || [], 'contactId');

  const [viewOnly, setViewOnly] = useState(false)
  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
  const [showActiveUserModal, setShowActiveUserModal] = useState(false)
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('columnSettingsContacts');
    return savedColumns
      ? JSON.parse(savedColumns)
      : initialColumnContacts.reduce((acc, column) => ({ ...acc, [column.id]: column.checked }), {});
  });
  const handleColumnToggle = (updatedColumns: any) => {
    setVisibleColumns(updatedColumns);
    localStorage.setItem('columnSettingsContacts', JSON.stringify(updatedColumns));
  }
  const idValue = 'dropdownMenuClickableInsise1';

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }
  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);


  const handleToggle = () => {
    const newToggleState = !currentToggleState;
    setShowActiveUserModal(true);
    setCurrentToggleState(newToggleState);
  }

  const handleCloseStatusModal = () => {
    setShowActiveUserModal(false);
    setCurrentToggleState(!currentToggleState)
  };

  const handleAddContact = () => {
    navigate('/contacts/AddContacts')
  }

  const handleDoubleClick = (items: any) => {
    handleRowDoubleClick(items);
    dispatch(setContactsData(items))
    navigate(`/contacts/ViewContacts/${items?.contactId}`)
  };

  useEffect(() => {
    refetchContacts();
  }, [])

  useEffect(() => {
    if (contactData) {
      dispatch(setContactsData(contactData));
    }
  }, [contactData, dispatch]);

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };
  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetchContacts();
    }
  }, [searchStr, sortOrder, sortBy]);

  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1);
  };
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };

  // const handleAddContacts = () => {
  //   setActivityTogglePopup(true);
  //   setIsEditing(false);
  //   setViewOnly(false);

  // };
  const handleClose = () => {
    setShowfilterModal(false)
  };
  const handleReload = () => {
    refetchContacts();
  };
  // const handleEditContacts = () => {
  //   setActivityTogglePopup(true);
  //   setIsEditing(true)
  //   setViewOnly(false);

  // };
  const handleEditContacts = () => {
    navigate(`/contacts/EditContacts/${selectedIndividualCheckboxId}`)
  }
  const handleViewDetails = () => {
    navigate(`/contacts/ViewContacts/${selectedIndividualCheckboxId}`)
  }
  const closeSidebar = () => {
    setActivityTogglePopup(false);
  };
  const items = [

    {
      label: "Active",
      onClick: () => {
        setShowActiveUserModal(true);
      },
      ToggleButton: <ToggleButton
        onChange={handleToggle}
        id="toggle"
        checked={currentToggleState}
        disableButton={!isAnyCheckboxChecked} />
    },
    // {
    //   label: 'Edit',
    //   tooltipLabel: 'Edit',
    //   icon: svgIcons.updateIcon,
    //   onClick: () => handleEditContacts(),
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   disableIcon: svgIcons.updateIcon
    // },
    { label: 'View Details', tooltipLabel: "View details", icon: svgIcons.eyeIcon, onClick: () => handleViewDetails(), disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked, disableIcon: svgIcons.eyeIcon, },
    { label: 'Refresh', tooltipLabel: "Refresh", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: handleReload, }
  ];
  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];
  const handlefilterManage = () => {
  };
  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    if (data?.isActive === true) {
      setCurrentToggleState(true)
    } else {
      setCurrentToggleState(false)
    }
  }

  // csv data 
  const headers = initialColumnContacts.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allContactsCSV?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};
    headers?.forEach(header => {
      csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
    });
    return csvRecord;
  }) || []

  return (
    <>
      <ActiveUserModal
        show={showActiveUserModal}
        handleClose={handleCloseStatusModal}
        data={contactData}
        setCurrentToggleState={setCurrentToggleState}
        refetch={refetchContacts}

      />


      <FilterModalContacts show={showfilterModal} handleClose={handleClose} />
      <ContactsSidebar activityTogglePopup={activityTogglePopup} viewOnly={viewOnly} closeSidebar={closeSidebar} isEditing={isEditing} contactData={contactData} refetchContacts={refetchContacts} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                buttonText="+ New Contact"
                buttonClass="add-popup ribbon-btn "
                onClickbtn={() => handleAddContact()}
                disabled={isAnyCheckboxChecked || isMoreThanOneChecked}
              />

              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row align-items-center">
                      <div className="col-md-4 col-sm-8 mb-2">
                        <h4 className="page-title color-red mb-1">Contacts</h4>
                      </div>
                      <div className="col-md-8 mb-2">
                        <div className='d-flex gap-2 justify-content-end flex-column flex-md-row gap-2 mb-1'>
                          {isFetching ? '' :
                            <CSVLink data={CsvData} headers={headers} filename={`Contact_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                              <i className="fa fa-file-export" />
                              Export To CSV
                            </CSVLink>
                          }
                          <ManageColumnContacts columns={initialColumnContacts} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} />
                          <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                          <div>
                            <div className=" icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Contact"
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Manage Users List */}
                  {/* <div className="table-responsive custom-table">
                    <Table dataSource={ContactstableData} columns={columns} onRowSelect={(keys: any[]) => setSelectedRowId(keys)} paginations={true} />
                  </div> */}
                  <div className="table-responsive custom-table">
                    <table className="table datanew dataTable no-footer table-hover">
                      <thead>
                        <tr>
                          <th>
                            {/* <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            /> */}

                          </th>
                          {initialColumnContacts.map((column) => (
                            visibleColumns[column.id] &&
                            <TableHeading
                              label={column.name}
                              sortedColumn={column.name}
                              columnId={column.name}
                              sortOrder='desc'
                              handleSort={() => handleSort(column?.key)}
                            />

                          ))}

                        </tr>
                      </thead>
                      <tbody>
                        {!isFetchingData && (
                          <>
                            {allContacts?.result?.data?.length > 0 ? (
                              <>
                                {allContacts?.result?.data.map((data: any, index: any) => {
                                  return (
                                    <tr
                                      key={data.contactId}
                                      onClick={() => handleRowClicked(data)}
                                      onDoubleClick={() => handleDoubleClick(data)}
                                      className={selectedIndividualCheckboxId.includes(data.contactId) ? 'selected-row' : ''}
                                    >
                                      <td>
                                        <div className='d-flex gap-2'>
                                          <TextField
                                            type="checkbox"
                                            fieldClass="form-check-input cursor-pointer"
                                            checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.contactId)}
                                            onChange={(e) => handleCheckItem(e, data)}
                                          />
                                          <Link to={`/contacts/EditContacts/${data?.contactId}`}
                                          >
                                            {svgIcons.updateIcon}
                                          </Link>
                                        </div>
                                      </td>

                                      {initialColumnContacts.map((column) => (
                                        visibleColumns[column.id] && (
                                          <td key={column.id}>
                                            {
                                              column.key === 'isActive' ? (
                                                data[column.key] === true ? (
                                                  <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                                ) : data[column.key] === false ? (
                                                  <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                                ) : (
                                                  <span className="badge badge-pill badge-status bg-soft-gray text-muted">None</span>
                                                )
                                              ) : (
                                                data[column.key] !== undefined && data[column.key] !== null ? (
                                                  typeof data[column.key] === 'object' && data[column.key] !== null ? (
                                                    data[column.key].value !== undefined ? (
                                                      data[column.key].value
                                                    ) : (
                                                      ''
                                                    )
                                                  ) : (
                                                    data[column.key]
                                                  )
                                                ) : (
                                                  ''
                                                )
                                              )}
                                          </td>
                                        )
                                      ))}
                                    </tr>
                                  );
                                })}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={7}>
                                  <NoRecordFound />
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                        {isLoading && <TableLoading />}
                      </tbody>


                    </table>
                  </div>
                  <Pagination
                    // totalResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : ((allUsers?.result?.value?.result?.pageNumber - 1) * allUsers?.result?.value?.result?.pageSize) + 1}
                    // toResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : Math.min(allUsers?.result?.value?.result?.pageNumber * allUsers?.result?.value?.result?.pageSize, allUsers?.result?.value?.result?.totalRecords)}
                    // ofResult={allUsers?.result?.value?.result?.totalRecords}
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allContacts?.result?.totalPages || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Contacts;
